// FILECONTENT_START src/common/components/Inputs/Autocomplete/index.ts
import Autocomplete from "./Autocomplete";
export default Autocomplete;
export type { AutocompleteProps } from "./Autocomplete";

// FILECONTENT_END src/common/components/Inputs/Autocomplete/index.ts